import classNames from 'classnames';
import React from 'react';
import { UpsellPanelSteps } from '../../../../../constants/upsellPanelEnumsAndConstants';
import { useUpsellWidgetContainer } from '../../../hooks/useUpsellWidgetContainerContext';
import { useUpsellWidgetModel } from '../../../hooks/useUpsellWidgetModelContext';

export const Step3LoginContent = () => {
    const model = useUpsellWidgetModel();
    const { baseProps, currentStep, headerFontClass } = useUpsellWidgetContainer();
    if (currentStep !== UpsellPanelSteps.Step3Login) {
        return null;
    }

    return (
        <>
            {baseProps.existingUsernameEntered ? (
                <>
                    <p className='ml-3 mb-0 user-exists-msg font-19'>Looks like you are already a member. Please enter your password to proceed.</p>
                </>
            ) :
                <>
                    {
                        !model.noLoginText &&
                        <h2 className={classNames(headerFontClass, 'font-circular-std-bold m-b-md')}>{model.loginText}</h2>
                    }
                    {
                        model.content.loginParagraph &&
                        <div dangerouslySetInnerHTML={{ __html: model.content.loginParagraph }}
                            className={classNames(
                                "upsell-panel-paragraph",
                                (model.usePopupOverlay || model.isEurekaFund) && ["font-circular-std-bold", headerFontClass]
                            )}></div>
                    }
                </>
            }
        </>
    );
};
